import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
const getTestRideState = createSelector(getState, (state) => state.testRide);
export const getTestRideDealerId = createSelector(getTestRideState, (state) => state.dealerId);
export const getTestRideIframe = createSelector(getTestRideState, (state) => state.isIframe);
export const getTestRideCategoryId = createSelector(getTestRideState, (state) => state.categoryId);
